// extracted by mini-css-extract-plugin
export default {"wrapper":"QVE_RA3OklCYKRuq5zoF"};